import StepHeader from '../StepHeader';
import { useAppSelector } from '../../app/hooks';
import { selectSessionBankName } from '../../app/slices/bank.slice';
import { useFormStepTranslation } from './useFormStepTranslation';

export const AuthenticationContext = () => {
	const { t } = useFormStepTranslation();
	const bankName = useAppSelector(selectSessionBankName)!;

	const subtitle = t('bank-account-login-message');
	return <StepHeader title={bankName} subtitle={subtitle} bankName={bankName} />;
};
